import { useTheme } from '../../../../hooks/useTheme';

import { ReactComponent as WarningIcon } from '../../../../icons/warning.svg';

import OkDialog from '../ok-dialog/OkDialog';

const WarningDialog = ({ isOpen, title, message, onClick, onClose }) => {
  const { getThemeVariable } = useTheme();

  return (
    <OkDialog
      isOpen={isOpen}
      title={title}
      message={message}
      onClick={onClick}
      onClose={onClose}
      icon={
        <WarningIcon width={56} height={56} style={{ color: getThemeVariable('status-warning') }} />
      }
    />
  );
};

export default WarningDialog;
